import { StageType } from '../types/product.types';

export const STAGE_TYPE_LABELS: Record<StageType, string> = {
  [StageType.OPEN]: 'Em Andamento',
  [StageType.WON]: 'Ganho',
  [StageType.LOST]: 'Perdido',
};

export const DEFAULT_STAGES = [
  { name: 'Novo Lead', order: 1, type: StageType.OPEN, color: '#94A3B8' },
  { name: 'Qualificado', order: 2, type: StageType.OPEN, color: '#3B82F6' },
  { name: 'Demo Agendada', order: 3, type: StageType.OPEN, color: '#8B5CF6' },
  { name: 'Proposta Enviada', order: 4, type: StageType.OPEN, color: '#F59E0B' },
  { name: 'Negociação', order: 5, type: StageType.OPEN, color: '#EC4899' },
  { name: 'Fechado Ganho', order: 6, type: StageType.WON, color: '#22C55E' },
  { name: 'Fechado Perdido', order: 7, type: StageType.LOST, color: '#EF4444' },
];
